import React,{useEffect} from "react";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/our-presence-breadcrumb.webp';
import MineralMap from "../Components/MineralMap";
import Cta from "../Components/Cta";
import KutchMap from "../Components/KutchMap";
import Certificates from "../Components/Certificates";
import ContactSection from "../Components/ContactSection";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import aboutPageSchema from "../Schema/AboutPageSchema";
import placeSchema from "../Schema/PlaceSchema";

const OurPresence=()=>{
    useEffect(() => {
                document.title =
                  "Our Global Presence | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Iris Impulse India Pvt. Ltd. exports bentonite & industrial minerals to clients across the globe with a strong, reliable supply network. Explore more about us!"
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/about-us/our-presence");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Our Global Presence | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Iris Impulse India Pvt. Ltd. exports bentonite & industrial minerals to clients across the globe with a strong, reliable supply network. Explore more about us!"
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/about-us/our-presence");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/our-presence.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Our Global Presence | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Iris Impulse India Pvt. Ltd. exports bentonite & industrial minerals to clients across the globe with a strong, reliable supply network. Explore more about us!"
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/our-presence.webp"
                );
              }
              }, []);

const organizationData = organizationSchema();
const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "About Us",
      url: "https://irisimpulse.com/about-us"
    },
    {
      name: "Our Global Presence",
    },
  ],
});
const aboutPageData = aboutPageSchema({
  url: "https://irisimpulse.com/about-us/our-presence",
  title: "Our Global Presence | Iris Impulse India Pvt. Ltd.",
  description:
    "Iris Impulse India Pvt. Ltd. exports bentonite & industrial minerals to clients across the globe with a strong, reliable supply network. Explore more about us!",
  image: "https://irisimpulse.com/Images/our-presence.webp",
});

const corporateOfficeData = placeSchema({
  name: "Iris Impulse India Pvt. Ltd. – Corporate Office",
  description:
    "Corporate office of Iris Impulse India Pvt. Ltd. in Gandhidham, Gujarat, India.",
  url: "https://irisimpulse.com/about-us/our-presence#corporate-office",
  address: {
    streetAddress: "Plot-39, Ward-7/C, Gurukul Road",
    addressLocality: "Gandhidham",
    addressRegion: "Gujarat",
    postalCode: "370201",
    addressCountry: "IN",
  },
});

const plantData = placeSchema({
  name: "Iris Impulse India Pvt. Ltd. – Manufacturing Plant",
  description:
    "Manufacturing and processing facility associated with Iris Impulse India Pvt. Ltd.",
  url: "https://irisimpulse.com/about-us/our-presence#manufacturing-plant",
  address: {
    // Add the verified plant address here
    streetAddress: "Ashirwad Minechem, Plot-199/200 & 203",
    addressLocality: "GIDC Durgapur, Mandvi-Kutch",
    addressRegion: "Gujarat",
    postalCode: "370465",
    addressCountry: "IN",
  },
});


    return(
        <>

      <SchemaMarkup data={organizationData} />
      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={aboutPageData} />
      <SchemaMarkup data={corporateOfficeData} />
      <SchemaMarkup data={plantData} />

          <BreadCrumb
  title="Our Global Presence" 
  bgImage={bgImg} 
/>
      {/**GLOBAL MINERAL SOLUTIONS ROOTED IN KUTCH SECTION */}
    <KutchMap />

      {/**MAP SECTION*/}
        <MineralMap />

          
    {/**CTA SECTION */}
    <Cta />

    {/**CERTIFICATES SECTION */}
    <Certificates/>

    {/**CONTACT FORM SECTION */}
    <ContactSection />
        </>
    )
}
export default OurPresence;